import { Flex, Tabs } from "antd";
import styled from "styled-components";

export const SalesWrap = styled(Tabs)`
  height: 100%;
  overflow: hidden;

  & .ant-tabs-content-holder,
  & .ant-tabs-content,
  & .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
  }

  & .ant-upload-wrapper {
    height: 100%;
    overflow: hidden;

    & .ant-upload-list {
      height: calc(100% - 50px);
      overflow: auto;
      margin-top: 10px;
    }
  }

  & td {
    height: 1px;
  }
`;

export const TableWrap = styled.div`
  & td {
    height: 1px;
  }
`;

export const TableCellWrap = styled(Flex)`
  height: 100%;
  & .edit-btn {
    display: none;
  }
  &:hover {
    & .edit-btn {
      display: block;
    }
  }
`;

export const CellSelectWrap = styled.span`
  width: calc(100% - 30px);
  cursor: text !important;

  > .ant-select-disabled {
    > .ant-select-selector {
      border: 1px solid transparent !important;
      background: transparent !important;
      color: rgba(0, 0, 0, 0.88) !important;
      cursor: text !important;

      > .ant-select-selection-placeholder {
        display: none;
      }
    }

    > .ant-select-arrow {
      display: none;
    }
  }

  & .ant-select .ant-select-selection-item > .ant-typography {
    display: block;
  }
`;

export const DictOption = styled(Flex)`
  width: 100%;

  > .dict-action {
    display: none;
  }

  &:hover {
    > .dict-action {
      display: block;
    }
  }
`;
